import { ROUTES } from "../../../../module/constants";

export const TEMPORARY_ABILITATIONS_MGMT_CONSOLE_ADMIN_URLS = {
  BASE_URL: ROUTES.ADMIN_TEMPORARY_ABILITATIONS_MGMT,
  STEP_ONE: `${ROUTES.ADMIN_TEMPORARY_ABILITATIONS_MGMT}/stepOne`,
  MANAGE_APPLICATIONS: `${ROUTES.ADMIN_TEMPORARY_ABILITATIONS_MGMT}/applicationsList`,
  APPLICATION_CONFIGURATION: `${ROUTES.ADMIN_TEMPORARY_ABILITATIONS_MGMT}/applicationConfiguration`,
  TEMPORARY_ABILITATION_ON_APPLICATION_CONFIGURATION: `${ROUTES.ADMIN_TEMPORARY_ABILITATIONS_MGMT}/temporaryAbilitationsOnApplicationConfiguration`,
  SUMMARY_TEMPORARY_ABILITATIONS_CONFIGURATION: `${ROUTES.ADMIN_TEMPORARY_ABILITATIONS_MGMT}/summaryTemporaryAbilitationsConfiguration`,
  MANAGE_TEMPORARY_ABILITATIONS: `${ROUTES.ADMIN_TEMPORARY_ABILITATIONS_MGMT}/temporaryAbilitationsList`,
  TEMPORARY_ABILITATIONS_CONFIGURATION: `${ROUTES.ADMIN_TEMPORARY_ABILITATIONS_MGMT}/temporaryAbilitationConfiguration`,
  EMERGENCY_ABILITATIONS_CONFIGURATION: `${ROUTES.ADMIN_TEMPORARY_ABILITATIONS_MGMT}/emergencyConfiguration`,
  EMERGENCY_ABILITATIONS_CONFIGURATION_SUMMARY: `${ROUTES.ADMIN_TEMPORARY_ABILITATIONS_MGMT}/summary`,
  TEMPORARY_ABILITATIONS_FIELDS_CONFIGURATION: `${ROUTES.ADMIN_TEMPORARY_ABILITATIONS_MGMT}/temporaryAbilitationFieldsConfiguration`,
};

export const STATE_IDENTIFIER = {
  APPLICATIONS: "applications",
  TOTAL_APPLICATIONS: "totalApplications",
  SELECTED_APPLICATION: "selectedApplication",
  SELECTED_APPLICATION_CONFIGURATION: "selectedApplicationConfiguration",
  TEMPORARY_ABILITATIONS: "temporaryAbilitations",
  SELECTED_TEMPORARY_ABILITATION: "selectedTemporaryAbilitation",
  CONFIGURATIONS: "configurations",
  BASIC_CONFIGURATION: "basicConfigurations",
  EMERGENCY_CONFIGURATION: "emergencyConfigurations",
  EDIT_EMERGENCY_CONFIGURATION: "editEmergencyConfiguration",
  UPDATE_EMERGENCY_CONFIGURATION_CALL_STATE:
    "updateEmergencyConfigurationCallState",
  SELECTED_EMERGENCY_CONFIGURATION: "selectedEmergencyConfiguration",
  GLOBAL_CATALOG: "globalCatalog",
  EMERGENCY_TOTAL_ENTITLEMENTS: "emergencyTotalEntitlements",
  EMERGENCY_ADDED_ENTITLEMENTS: "emergencyAddedEntitlements",
  EMERGENCY_DELETED_ENTITLEMENTS: "emergencyDeletedEntitlements",
  ROLES: "roles",
  FIELDS: "fields",
  NEW_ADDED_ROLES: "newAddedRoles",
  TOTAL: "total",
  PREVIOUS: "previous",
  ADDED: "added",
  REMOVED: "removed",
  REQUEST_STATE: "requestState",
  RESPONSE_MESSAGE: "responseMessage",
  REQUEST_STATE_ROLES_CREATION: "requestStateRolesCreation",
  SYSTEM_USERS: "systemUsers",
};

export const LIST_IDENTIFIER: string = "list";
export const LOADER_IDENTIFIER: string = "loader";

export interface IApplicationConfigurationTemporaryAbilitationsMgmt {
  applicationId: string;
  identitySystemId: string;
  pool: boolean;
  targetAttribute: string;
  technicalUser: string;
}

export interface ICallBodyApplicationConfigurationTemporaryAbilitationsMgmt {
  body: IApplicationConfigurationTemporaryAbilitationsMgmt;
  applicationId: string;
  identitySystemId: string;
}

export interface ITemporaryEntitlementConfigurationMgmtBody {
  entitlementId: string;
  identitySystemId: string;
  roles: string;
  maxHours: number;
  emergencyName?: string;
  id?: number | string;
  uniqueId?: number | string;
}
